import { useCallback, useEffect } from "react";

export default function TabAwayListener({ children, tabRef, enabled = true, tabAwayHandler = (e) => {} }) {
    
    const onTabListener = useCallback((event) => {
        if(enabled && event?.key && event.key.toLocaleUpperCase() === "TAB" && tabRef.current && !tabRef.current.contains(event.target)) {
            return tabAwayHandler(event);
        }
    }, [tabAwayHandler, enabled ,tabRef]);

    useEffect(() => {
        document.addEventListener("keyup", onTabListener);
        return () => {
            document.removeEventListener("keyup", onTabListener);
        }
    }, [onTabListener])

    return children;
}